import { useMemo } from "react";
import { withRelativeBarPct } from "creso-core/utils";
import { ExposureCard } from "web-core";
import { PortfolioDistributionData } from "creso-core/types";
import { OverviewSection } from "./overview-section";

type PortfolioDistributionProps = PortfolioDistributionData & {
  label?: string;
  defaultOpen?: boolean;
};

export function PortfolioDistribution({
  stocks,
  sectors,
  label = "Portfolio Distribution",
  defaultOpen,
}: PortfolioDistributionProps) {
  const stocksExposure = useMemo(() => withRelativeBarPct(stocks), [stocks]);
  const sectorExposure = useMemo(() => withRelativeBarPct(sectors), [sectors]);

  if (!stocksExposure.length && !sectorExposure.length) return null;

  return (
    <OverviewSection label={label} defaultOpen={defaultOpen}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <ExposureCard title="Stocks" rows={stocksExposure} />
        <ExposureCard title="Sector" rows={sectorExposure} />
      </div>
    </OverviewSection>
  );
}

/** @deprecated Use `PortfolioDistribution` */
export const PorfolioDistribution = PortfolioDistribution;
